import * as Yup from 'yup';
import { RedirectForm } from '@composite/redirect/dialog-redirect';
import { Agenda } from '@enums';

export function useValidationSchema() {
  return Yup.object().shape({
    agenda: Yup.mixed<Agenda>().nullable().required(),
  }) as Yup.Schema<RedirectForm & { agenda: Agenda }>;
}
